import Styled from 'styled-components';

export const Footer = Styled.div`
  color: #6699cc;
  margin-top: 15px;
  font-size: 12px;
  p {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  }
`;

export const FooterLogoContainer = Styled.div`
  float: left;
`;

export const FooterText = Styled.div`
    float: left;
    margin-left: 6px;
`;

export const FooterTextLine1 = Styled.p`
    margin: 8px 0px 0px;
`;

export const FooterTextLine2 = Styled.p`
    margin: 0px;
`;

export const StatusLabel = Styled.span`
  display: inline-block;
  margin-right: 10px;
  ${(props) => props.offline && 'color: #ff0000;'}
  ${(props) => props.deprecated && 'color: #ffa701;'}
`;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Layout/styles.js